import React, { useEffect, useMemo, useState } from "react";
import { FashBusinesses, SignedUpBusinesses } from "../../pages";
import { BusinessController } from "../../controllers";
import { useStores } from "../../stores";
import { useNavigate } from "react-router-dom";
import constant from "../../utils/constant";

const FashBusinessesContainer = () => {
  const [ViewMoreModal, setViewMoreModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const { businessStore } = useStores();
  const { signedUpBusinesses, signedupBusinessesAnalysis } =
    businessStore || {};
  const [infoModal, setInfoModal] = useState("stage1");
  const [todoModal, setTodoModal] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableList, setTableList] = useState("");
  const [isOnlyParent, setIsOnlyParent] = useState(false);

  const navigate = useNavigate();

  const signedUpBizTableQuery = useMemo(() => {
    let queryString = `offset=${currentPage + 1}&limit=${limit}&onlyParent=${isOnlyParent}&isFash=true`;
    if (tableList && tableList !== "") {
      queryString += `&tableList=${tableList}`;
    }
    return queryString;
  }, [currentPage, limit, tableList, isOnlyParent]);

  const { isLoading, data, isFetching } =
    BusinessController.useGetAllSignedBusinesses(
      signedUpBizTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const options1 = [
    {
      label: "Approve",
      value: "Approve",
    },
    {
      label: "View More",
      value: "View More",
    },
    {
      label: "List Invoices",
      value: "List Invoices",
    },
    {
      label: "View Todo Info",
      value: "View Todo Info",
    },
  ];

  const options2 = [
    {
      label: "Suspend",
      value: "Suspend",
    },
    {
      label: "View More",
      value: "View More",
    },
    {
      label: "List Invoices",
      value: "List Invoices",
    },
    {
      label: "View Todo Info",
      value: "View Todo Info",
    },
  ];

  const handleApprove = () => {
    setViewMoreModal(true);
    setInfoModal("stage2");
  };

  const handleViewMore = () => {
    setViewMoreModal(true);
    setInfoModal("stage1");
  };

  const handleListInvoices = () => {
    navigate(constant.Routes.InvoiceReceipt);
  };
  const handleViewTodo = () => {
    setTodoModal(true);
  };

  const closeModal = () => {
    setViewMoreModal(false);
    setTodoModal(false);
  };

  return (
    <FashBusinesses
      options1={options1}
      options2={options2}
      loading={loading}
      infoModal={infoModal}
      setInfoModal={setInfoModal}
      signedUpBusinesses={signedUpBusinesses}
      closeModal={closeModal}
      ViewMoreModal={ViewMoreModal}
      handleViewMore={handleViewMore}
      handleApprove={handleApprove}
      handleListInvoices={handleListInvoices}
      isFetching={isFetching}
      fashData={data}
      isLoading={isLoading}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setFilterQuery={setFilterQuery}
      setSearchQuery={setSearchQuery}
      setTableList={setTableList}
      setIsOnlyParent={setIsOnlyParent}
      isOnlyParent={isOnlyParent}
      handleViewTodo={handleViewTodo}
      todoModal={todoModal}
    />
  );
};
export default FashBusinessesContainer;
